import React from "react";
import { useParams, useLocation } from "react-router-dom";
import { Form } from "antd";
import { useNavigate } from "react-router-dom";

import { GetAliasForm } from "../components/GetAliasForm";
import { MercadoPagoErroCallbackInfo } from "../components/MercadoPagoErroCallbackInfo";

export function MercadoPagoCallback() {
  const { countryCode } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const params = {
    code: queryParams.get("code"),
    state: queryParams.get("state"),
    error: queryParams.get("error"),
    errorDescription: queryParams.get("error_description"),
  };

  const [form] = Form.useForm();

  const handleFormSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        navigate(
          `/mercadopago/link/success?code=${params.code}&alias=${
            values.alias
          }&countryCode=${countryCode.toUpperCase()}`
        );
      })
      .catch((errorInfo) => {
        console.log("Error in form: ", errorInfo);
      });
  };

  if (params.code) {
    return <GetAliasForm form={form} onFinish={handleFormSubmit} />;
  }

  return <MercadoPagoErroCallbackInfo params={params} />;
}
